import React from "react";
import { MdClose } from "react-icons/md";

const PopUp = ({ isOpen, onClose, title, titleStyling = '', children, PopUpWidth = '' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full">
      {/* Background Layer */}
      <div
        className="absolute inset-0 bg-dblackk bg-opacity-40"
        // onClick={onClose}
      />

      {/* PopUp Container */}
      <div
        className={`relative z-10 bg-white rounded-md p-6 w-3/4 ${
          PopUpWidth ? PopUpWidth : 'md:w-full max-w-md'
        } shadow-lg`}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl"
        >
          <MdClose />
        </button>

        {title && (
          <h2 className={`text-xl md:text-lg font-semibold mb-4 capitalize ${titleStyling}`}>
            {title}
          </h2>
        )}

        <div>{children}</div>
      </div>
    </div>
  );
};

export default PopUp;
